import clsx from 'clsx';
import React from 'react';

import { Table, flexRender } from '@tanstack/react-table';

import { PIN_LEFT, isPinnedLeft } from '.';
import { DataTableColumnHeader } from './DataTableColumnHeader';

interface DataTableTheadProps<TData> extends React.HTMLAttributes<HTMLTableSectionElement> {
  classNameTh?: string;
  classNameThead?: string;
  Table: Table<TData>;
}

function DataTableThead<TData>({ classNameTh, classNameThead, Table }: DataTableTheadProps<TData>) {
  return (
    <thead className={classNameThead}>
      {Table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            return (
              <th
                key={header.id}
                className={clsx(
                  classNameTh,
                  'border-0 border-b-2 border-r border-solid border-b-primary-magenta border-r-grayscale-beige bg-white px-16 py-10 text-left text-caption-sm capitalize',
                  {
                    'cursor-pointer': header.column.getCanSort(),
                    'bg-grayscale-beige': header.column.getIsSorted(),
                    'sticky z-10': isPinnedLeft(header.column),
                  }
                )}
                colSpan={header.colSpan}
                style={{
                  minWidth: header.getSize(),
                  left: isPinnedLeft(header.column)
                    ? `${header.column.getStart(PIN_LEFT)}px`
                    : undefined,
                }}
              >
                <DataTableColumnHeader
                  key={header.id}
                  column={header.column}
                  title={
                    header.isPlaceholder
                      ? null
                      : (flexRender(header.column.columnDef.header, header.getContext()) as string)
                  }
                />
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
}

export default DataTableThead;
